import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, createUrlTreeFromSnapshot} from '@angular/router';
import { map } from 'rxjs';
import { UserAuthService }  from "../services/user-auth.service";

export const requiredPrivilegeGuard = (next: ActivatedRouteSnapshot) => {
  let requiredPrivileges: string[] = next.data?.['privileges'];
  const service = inject(UserAuthService);
  return service
    .arePrivilegesGranted(requiredPrivileges)
    .pipe(
      map((isAuthorized) =>
      isAuthorized ? true : createUrlTreeFromSnapshot(next, ['/', 'cv-comp'])
      )
    );
};

